function updateViewportFlags() {
  window.isMobile = window.innerWidth <= 768;
  window.isTablet = window.innerWidth <= 1024;
  window.isSmallLaptop = window.innerWidth <= 1280;
}

updateViewportFlags();
window.addEventListener('resize', updateViewportFlags);

function pushIntelligemsEvent(eventName, payload = {}) {
  window.igEvents = window.igEvents || [];
  window.igEvents.push(Object.assign({ event: eventName }, payload));
}

function isElementVisible(element) {
  if (!element) {
    return false;
  }

  const styles = window.getComputedStyle(element);
  const rect = element.getBoundingClientRect();

  return styles.display !== 'none'
    && styles.visibility !== 'hidden'
    && styles.opacity !== '0'
    && rect.width > 0
    && rect.height > 0;
}

document.querySelectorAll('.js-show-menu').forEach((button) => {
  button.addEventListener('click', function(event) {
    event.stopPropagation();
    event.preventDefault();
    document.body.classList.toggle('mopen');
  });
});


function initMenu(menu) {
  const panels = menu.querySelectorAll('[data-menu-panel]');
  const panelTriggers = menu.querySelectorAll('[data-menu-target]');
  const panelsContainer = menu.querySelector('.menu__panels');
  if (!panelsContainer) return;
  let isPanelTransitioning = false;
  let panelTransitionId = 0;
  let resetSubmenuHoverDelay = () => {};

  // panels.forEach((panel) => {
  //   const panelItems = panel.querySelectorAll('.menu__nav-group, .menu__back, .menu__products');
  //   panelItems.forEach((item, index) => {
  //     item.style.setProperty('--menu-item-delay', `${100 + index * 55}ms`);
  //   });
  // });

  const delayInitialSubmenuHover = (panel) => {
    resetSubmenuHoverDelay();
    if (!panel.classList.contains('menu__panel--submenu')) return;

    let timeoutId;

    const enableHover = () => {
      if (timeoutId) window.clearTimeout(timeoutId);
      panel.removeEventListener('pointerout', handlePointerOut);
      panel.classList.remove('menu__panel--hover-delayed');
    };

    const handlePointerOut = (event) => {
      const product = event.target.closest('.menu__product');
      if (!product || !panel.contains(product)) return;
      if (event.relatedTarget && product.contains(event.relatedTarget)) return;

      enableHover();
    };

    panel.classList.add('menu__panel--hover-delayed');
    panel.addEventListener('pointerout', handlePointerOut);
    timeoutId = window.setTimeout(enableHover, 1000);
    resetSubmenuHoverDelay = enableHover;
  };

  const showPanel = (panelName) => {
    const targetPanel = Array.from(panels).find((panel) => panel.dataset.menuPanel === panelName);
    const currentPanel = Array.from(panels).find((panel) => !panel.hidden);
    if (!targetPanel || isPanelTransitioning) return;

    if (!currentPanel || currentPanel === targetPanel) {
      panels.forEach((panel) => {
        const isActive = panel === targetPanel;
        panel.hidden = !isActive;
        panel.setAttribute('aria-hidden', String(!isActive));
      });

      menu.classList.toggle('menu--submenu', panelName !== 'main');
      delayInitialSubmenuHover(targetPanel);
      return;
    }

    isPanelTransitioning = true;
    const isEnteringSubmenu = panelName !== 'main';
    const leaveClass = isEnteringSubmenu
      ? 'menu__panel--leaving-forward'
      : 'menu__panel--leaving-back';
    const transitionId = ++panelTransitionId;
    const currentHeight = currentPanel.offsetHeight;

    const finishTransition = (event) => {
      if (event.target !== targetPanel) return;

      targetPanel.removeEventListener('animationend', finishTransition);
      if (transitionId !== panelTransitionId) return;

      currentPanel.hidden = true;
      currentPanel.classList.remove(leaveClass);
      panelsContainer.classList.remove('menu__panels--transitioning');
      panelsContainer.style.height = '';
      isPanelTransitioning = false;
    };

    targetPanel.addEventListener('animationend', finishTransition);
    targetPanel.hidden = false;
    targetPanel.setAttribute('aria-hidden', 'false');
    currentPanel.setAttribute('aria-hidden', 'true');

    menu.classList.toggle('menu--submenu', panelName !== 'main');
    const targetHeight = targetPanel.offsetHeight;
    panelsContainer.style.height = `${currentHeight}px`;
    panelsContainer.classList.add('menu__panels--transitioning');
    currentPanel.classList.add(leaveClass);

    delayInitialSubmenuHover(targetPanel);

    requestAnimationFrame(() => {
      if (transitionId === panelTransitionId) {
        panelsContainer.style.height = `${targetHeight}px`;
      }
    });
  };

  const resetMenu = () => {
    panelTransitionId += 1;
    resetSubmenuHoverDelay();
    panels.forEach((panel) => {
      const isMainPanel = panel.dataset.menuPanel === 'main';
      panel.hidden = !isMainPanel;
      panel.setAttribute('aria-hidden', String(!isMainPanel));
      panel.classList.remove('menu__panel--leaving-forward', 'menu__panel--leaving-back');
    });
    panelsContainer.classList.remove('menu__panels--transitioning');
    panelsContainer.style.height = '';
    menu.classList.remove('menu--submenu');
    isPanelTransitioning = false;
  };

  const menuSection = menu.closest('.section--menu');
  if (menuSection) {
    menuSection.addEventListener('transitionend', (event) => {
      const menuIsClosed = !document.body.classList.contains('mopen');
      if (event.target === menuSection && event.propertyName === 'transform' && menuIsClosed) {
        resetMenu();
      }
    });
  }


  menu.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-menu-target]');
    if (!trigger) return;

    event.preventDefault();
    showPanel(trigger.dataset.menuTarget);
  });
  resetMenu();
}

document.addEventListener('click', function(event) {
  const menu = document.querySelector('.menu');
  if (document.body.classList.contains('mopen') && !menu.contains(event.target)) {
    document.body.classList.remove('mopen');
  }
});

if (document.querySelector('.menu')) {
  let menu = document.querySelector('.menu');
  menu.addEventListener('click', function(event) {
    event.stopPropagation();
  });
  initMenu(menu);
}




class MiniCart extends HTMLElement {
  constructor() {
    super();
    this.bookAddonsViewed = false;
    this.initialized = false;
    this.currencyLoaded = false;
  }

  connectedCallback() {
    this.init();
    if (!this.initialized && !this.cartObserver) {
      this.cartObserver = new MutationObserver(() => this.init());
      this.cartObserver.observe(document.body, { childList: true, subtree: true });
    }
  }

  disconnectedCallback() {
    if (this.cartObserver) {
      this.cartObserver.disconnect();
      this.cartObserver = null;
    }
  }

  init() {
    if (this.initialized) return;
    const cartButton = document.querySelector('.cart__show');
    if (!cartButton || !this.querySelector('.cart-block')) return;

    cartButton.addEventListener('click', (event) => {
      event.preventDefault();
      this.toggle();
    });

    this.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.close();
    });
    this.initElemens();
    this.initialized = true;
    if (this.cartObserver) {
      this.cartObserver.disconnect();
      this.cartObserver = null;
    }
  }

  initElemens() {

    const cartBlock = this.querySelector('.cart-block');
    if (cartBlock) {
      cartBlock.addEventListener('click', (event) => {
        event.stopPropagation();
      });
    }

    this.querySelectorAll('.js-close-cart').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        this.close();
      });
    });

    document.querySelectorAll('mini-cart .cart-item__quantity-button, .cart-block--cart-page .cart-item__quantity-button').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const input = button.parentElement.querySelector('input');
        const quantity = parseInt(input.value);
        const max = input.hasAttribute('max') ? parseInt(input.max) : null;
        if (button.name === 'minus') {
          input.value = quantity - 1 <= 1 ? 1 : quantity - 1;
        } else {
          input.value = max && quantity + 1 >= max ? max : quantity + 1;
        }
        let newQuantity = parseInt(input.value);
        if (newQuantity !== quantity) {
          this.updateQuantity(button.dataset.index, input.value);
          button.classList.add('is-loading');
        }
      });
    });

    document.querySelectorAll('mini-cart .cart-item__quantity-input, .cart-block--cart-page .cart-item__quantity-input').forEach((input) => {
      input.addEventListener('change', (event) => {
        event.preventDefault();
        const quantity = parseInt(input.value);
        const max = input.hasAttribute('max') ? parseInt(input.max) : null;
        if (quantity < 1) {
          input.value = 1;
        } else if (max && quantity > max) {
          input.value = max;
        }
        this.updateQuantity(input.dataset.index, input.value);
      });
      input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
        }
      });
    });

    document.querySelectorAll('mini-cart .cart-item__delete, .cart-block--cart-page .cart-item__delete').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        this.updateQuantity(button.dataset.index, 0);
        button.classList.add('is-loading');
      });
    });


    this.querySelectorAll('.js-quick-update-cart').forEach((form) => {
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const button = event.target.querySelector('button');
        button.classList.add('is-loading');
        let data = new FormData(form);
        addToCart(data, button, form.dataset.cartAddonSource === 'book_addons');
      });
    });

    this.trackBookAddonsView();
  }

  close() {
    document.querySelector('body').classList.remove('cart-open');
    this.bookAddonsViewed = false;
  }
  open() {
    document.querySelector('body').classList.add('cart-open');
    this.trackBookAddonsView();
  }
  toggle() {
    document.querySelector('body').classList.toggle('cart-open');
    if (document.querySelector('body').classList.contains('cart-open')) {
      this.trackBookAddonsView();
    } else {
      this.bookAddonsViewed = false;
    }
  }

  trackBookAddonsView() {
    if (this.bookAddonsViewed || !document.querySelector('body').classList.contains('cart-open')) {
      return;
    }

    setTimeout(() => {
      document.querySelectorAll('[data-cart-book-addons="true"]').forEach((section) => {
        if (this.bookAddonsViewed || !isElementVisible(section)) {
          console.log('book addons not visible, not tracking');
          return;
        }

        this.bookAddonsViewed = true;
        pushIntelligemsEvent('cart_book_addons_viewed');
      });
    }, 1000);
  }

  getSectionsToRender() {
    const sections = [
      {
        id: 'cart-drawer',
        section: 'template-cart-drawer',
        selector: '.cart-block',
      },
      {
        id: 'template-cart-count',
        section: 'template-cart-count',
        selector: '.cart__show-text',
      },
    ];
    const cartPage = document.querySelector('.cart-block--cart-page');
    const pageSection = cartPage && cartPage.closest('[id^="shopify-section-"]');
    if (pageSection) {
      sections.push({
        id: pageSection.id,
        section: pageSection.id.replace('shopify-section-', ''),
        selector: '.cart-block--cart-page',
      });
    }
    return sections;
  }

  updateQuantity(line, quantity) {
    const body = JSON.stringify({
      line: line,
      quantity: parseInt(quantity),
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    document.querySelector('.cart-item[data-index="' + line + '"]').classList.add('is-loading');

    return fetch(`${routes.cart_change_url}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json','Accept': 'application/json'},
      body,
     })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        if (parsedState.errors || parsedState.status) {
          return this.load().then(() => {
            this.handleErrors(parsedState.description || parsedState.errors || parsedState.message);
          });
        }
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace = section.section === 'template-cart-drawer'
            ? this.querySelector(section.selector)
            : document.querySelector(section.selector);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        this.initElemens();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: parsedState } }));
      })
      .catch((e) => {
        this.handleErrors();
      })
      .finally(() => {
        let cartItem = document.querySelector('.cart-item[data-index="' + line + '"]');
        if (cartItem) {
          cartItem.classList.remove('is-loading');
        }
      });
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleErrors(error) {
    let e = document.createElement('div');
    if (!error) {
      error = 'An error occurred while updating the cart. Please try again.';
    } else if (typeof error === 'string') {
      if (error.indexOf('product-bulk') !== -1) {
        error = 'You can add up to 8 items to your cart. For bulk orders, please contact us at <a href="mailto:book@hungryminds.com">book@hungryminds.com</a>';
      }
    } else if (typeof error === 'object') {
      error = error.description;
    }
    
    e.innerHTML = `
      <div class="alert alert--hidden">
        <img src="https://cdn.shopify.com/s/files/1/0933/6717/3410/files/box.svg?v=1751529832" alt="box" class="alert__icon">
        <div class="alert__block">
          <span class="alert__text">
            ${error}
          </span>
        </div>
      </div>
    `;
    let wrapper = document.querySelector('.alert__wrapper');
    wrapper.insertBefore(e, wrapper.firstChild);

    setTimeout(() => {
      e.querySelector('.alert').classList.remove('alert--hidden');
    }, 100);
    setTimeout(() => {
      e.querySelector('.alert').classList.add('alert--hidden');
    }, 4900);
    setTimeout(() => {
      e.remove();
    }, 5000);
  }
  load() {
    const body = JSON.stringify({
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    return fetch(`${routes.cart_update_url}`, { 
      method: 'POST',
      headers: { 'Content-Type': 'application/json','Accept': 'application/json'},
      body,
    }).then((response) => {
      return response.json();
    }).then((state) => {

      //test if client currency is different from server currency
      if (!this.currencyLoaded && Shopify.currency && state.currency !== Shopify.currency.active) {
        return fetch('/services/currency/update?currency=' + Shopify.currency.active + '&country=' + Shopify.country)
          .then(() => {
            this.currencyLoaded = true;
            return this.load();
          })
          .then(() => {
            return Promise.reject('currency_reload');
          });
      } else {
        return new Promise((resolve) => {
          resolve(state);
        });
      }
    }).then((state) => {
      if (!state.sections) {
        return;
      }
      this.getSectionsToRender().forEach((section) => {
        const elementToReplace = section.section === 'template-cart-drawer'
          ? this.querySelector(section.selector)
          : document.querySelector(section.selector);
        elementToReplace.innerHTML = this.getSectionInnerHTML(
          state.sections[section.section],
          section.selector
        );
      });
      this.initElemens();
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: state } }));
    }).catch((err) => {
      if (err === 'currency_reload') {
        return;
      }
      document.location.href = window.routes.cart_url;
      throw err;
    });
  }
}
customElements.define('mini-cart', MiniCart);


document.querySelectorAll('.js-product-form').forEach((form) => {

  function handleQuantityChange(event) {
    const value = parseInt(quantityInput.value);
    const max = quantityInput.hasAttribute('max') ? parseInt(quantityInput.max) : null;
    if (event.currentTarget.name === 'plus') {
      quantityInput.value = max && value + 1 >= max ? max : value + 1;
    } else if (event.currentTarget.name ==='minus' && value > 1) {
      quantityInput.value = value - 1;
    }
  }

  form.addEventListener('submit', (event) => {
    event.preventDefault();

    let data = new FormData(form);
    addToCart(data, button);
  });

  let button = form.querySelector('button[type="submit"]');
  let quantityInput = form.querySelector('.product-info__quantity-input');
  let quantityButtons = form.querySelectorAll('.product-info__quantity-button');
  
  quantityButtons.forEach((button) => {
    button.addEventListener('click', handleQuantityChange);
  });
});

function addToCart(data, button = null, trackBookAddonAdded = false) {
  let dataObj = {
    method: 'POST',
    body: data,
  };

  let clsLoading = 'is-loading';
  if (button) {
    button.classList.add(clsLoading);
    button.disabled = true;
  }

  fetch(routes.cart_add_url + '.js', dataObj)
    .then((response) => response.json())
    .then((response) => {
      
      if (data.get('action_type') === 'replace') {
        dataObj.body.set('id', data.get('remove_line'));
        dataObj.body.set('quantity', 0);
        return fetch(routes.cart_change_url + '.js', dataObj)
          .then((response) => response.json())
      }
      return new Promise((resolve) => {
        resolve(response);
      });
    })
    .then((response) => {
      if (response.status) {
        if (button) {
          button.classList.remove(clsLoading);
          button.disabled = false;
        }
        document.querySelector('mini-cart').handleErrors(response.message);
        return;
      }

      const miniCart = document.querySelector('mini-cart');
      if (trackBookAddonAdded) {
        pushIntelligemsEvent('cart_book_addon_added');
      }
      miniCart.load().then(() => {
        miniCart.open();
        if (button) {
          button.classList.remove(clsLoading);
          button.disabled = false;
        }
      });
      
    })
    .catch((error) => console.log(error));
}

let lastScrollTop = 0;
let scrollTimeoutId = null;

let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);
document.documentElement.style.setProperty('--ivh', `${vh}px`);

window.addEventListener('resize', () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});
const isV3 = false && !!document.querySelector('.template-index');
const hasAnouncement = !!document.querySelector('.section--announcement-banner');
window.addEventListener('scroll', function() {
  let currentScrollTop = window.scrollY || document.documentElement.scrollTop;

  const stickyElm = document.querySelector('body');
  const header = stickyElm.querySelector('.header');
  let scrollOffset = 80;
  let onTopOffset = 0;
  if (isV3 && !hasAnouncement) {
    scrollOffset = window.innerHeight;
    onTopOffset = window.innerHeight;
  }
  

  clearTimeout(scrollTimeoutId);

  if (currentScrollTop > scrollOffset) {
    stickyElm.classList.add('is-pinned');
    if (Math.abs(currentScrollTop - lastScrollTop) < 10) {
      return;
    }
    if (currentScrollTop < lastScrollTop) {
      stickyElm.classList.add('is-fixed');
      if (currentScrollTop <= 200) {
        stickyElm.classList.remove('is-to-top');
      } else {
        stickyElm.classList.add('is-to-top');
      }
      header.style.transform = null;
    } else {
      header.style.transform = 'translateY(-200%)';
      stickyElm.classList.remove('is-to-top');
      scrollTimeoutId = setTimeout(() => {
        stickyElm.classList.remove('is-fixed');  
      }, 300);
    }
  } else if (currentScrollTop <= onTopOffset) {
    stickyElm.classList.remove('is-pinned');
    stickyElm.classList.remove('is-fixed');
    stickyElm.classList.remove('is-to-top');
    header.style.transform = null;
  }

  lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
});


(function videoReviews() {
  new Swiper('.js-video-reviews', {
    slidesPerView: 1.3,
    spaceBetween: 10,
    centeredSlides: true,
    loop: true,
    navigation: {
      prevEl: '.slider-product__arrow--left',
      nextEl: '.slider-product__arrow--right',
    },

    a11y: {
      scrollOnFocus: false,
    },
    pagination: {
      el: '.slider-product__circles',
      clickable: true,
      renderCustom: function (swiper, current, total) {
        let visibleDots = 7;
        let start = Math.max(current - Math.floor(visibleDots / 2), 1);
        let end = start + visibleDots - 1;

        if (end > total) {
          end = total;
          start = Math.max(end - visibleDots + 1, 1);
        }

        let dots = '';
        for (let i = start; i <= end; i++) {
          dots += `<button role="button" aria-label="Show slide ${i}" class="slider-product__circle ${i === current ? 'active' : ''}" data-index="${i - 1}"></span>`;
        }

        return dots;
      },
      type: 'custom'
    },
    on: {
      paginationRender(swiper) {
        document.querySelector('.slider-product__circle').addEventListener('click', function (e) {
          if (e.target.classList.contains('slider-product__circle')) {
            const index = parseInt(e.target.getAttribute('data-index'));
            swiper.slideTo(index);
          }
        });
      },
      slideChange(swiper) {
        swiper.pagination.render();
        swiper.pagination.update();
      },
      realIndexChange(swiper) {
        swiper.hostEl.querySelectorAll('video').forEach((v) => {
          if (!v.paused && !v.ended && v.readyState > 2) {
            v.pause();
          }
        })
      },
    },
    breakpoints: {
      1200: {
        slidesPerView: 4,
        centeredSlides: false,
        loop: false,
      },
      992: {
        slidesPerView: 3,
        centeredSlides: false,
        loop: false,
      },
      768: {
        slidesPerView: 2,
      }
    }
  });

  document.querySelectorAll('.videos__item-play').forEach((v) => {
    v.addEventListener('click', (event) => {
      event.preventDefault();
      event.currentTarget.parentElement.classList.add('playing');
      let video = event.currentTarget.parentElement.querySelector('video');
      document.querySelectorAll('video').forEach((v) => {
        v.pause();
      });
      video.play();
      video.setAttribute('controls', true);
    })
  });

  document.querySelectorAll('.videos__item video').forEach((v) => {
    let videoPauseTimeout = null;
    function onPauseVideo() {
      clearTimeout(videoPauseTimeout);
      videoPauseTimeout = setTimeout(() => {
        if (!v.paused || v.seeking) {
          return;
        }
        v.parentElement.classList.remove('playing');
        v.removeAttribute('controls');
        if (document.activeElement === v) {
          v.blur();
        }
      }, 50);
    }

    v.addEventListener('pause', onPauseVideo);
    v.addEventListener('ended', onPauseVideo);
    v.addEventListener('seeked', onPauseVideo);
  });
})();

document.querySelectorAll('.product-gallery').forEach((gallery) => {
  let thumbs = gallery.querySelector('.product-gallery__list');
  const sliderBot = gallery.querySelector('.product-gallery__slider-bot');
  let galleryThumbs;
  if (thumbs) {
    galleryThumbs = new Swiper(thumbs, {
      direction: 'vertical',
      slidesPerView: 'auto',
      spaceBetween: 5,
    });
  }
  function setupGalleryMediaHeight() {
    const image = gallery.querySelector('.product-gallery__slider-item > img, .product-gallery__slider-item picture > img');
    if (!image) {
      return () => {};
    }

    const setHeight = () => {
      const height = image.offsetHeight || image.getBoundingClientRect().height;
      if (!height) {
        return;
      }

      gallery.style.setProperty('--product-gallery-media-height', `${height}px`);
    };

    const updateHeight = () => requestAnimationFrame(setHeight);

    updateHeight();
    if (!image.complete) {
      image.addEventListener('load', updateHeight, { once: true });
    }
    window.addEventListener('resize', updateHeight);
    return updateHeight;
  }

  function updateGalleryVideoState(swiper) {
    const videos = swiper.el.querySelectorAll('video');
    if (!videos.length) {
      return;
    }

    videos.forEach((video) => {
      video.currentTime = 0;
    });

    if (!sliderBot) {
      return;
    }

    const activeSlide = swiper.slides[swiper.activeIndex] || swiper.el.querySelector('.swiper-slide-active');
    sliderBot.style.opacity = activeSlide && activeSlide.querySelector('video') ? '0' : '1';
  }

  const updateGalleryMediaHeight = setupGalleryMediaHeight();

  new Swiper(gallery.querySelector('.product-gallery__slider-wrap'), {
    thumbs: thumbs ? {
      swiper: galleryThumbs,
      slideThumbActiveClass: 'active',
    } : null,
    navigation: {
      nextEl: '.product-gallery__arrow--right',
      prevEl: '.product-gallery__arrow--left',
    },
    pagination: {
      el: '.product-gallery__lines',
      clickable: true,
      bulletClass: 'product-gallery__line',
      bulletActiveClass: 'active',
    },

    on: {
      init(swiper) {
        updateGalleryMediaHeight();
        updateGalleryVideoState(swiper);
      },
      slideChange(swiper) {
        updateGalleryVideoState(swiper);
      },
    },
  });
});

document.querySelectorAll('.js-accordion-title').forEach((title) => {
  title.addEventListener('click', (e) => {
    const content = e.currentTarget.nextElementSibling;
    const parent = e.currentTarget.parentElement;
    
    if (parent.classList.contains('active')) {
      content.style.maxHeight = 0;
    } else {
      content.style.maxHeight = content.scrollHeight + 'px';
      if (content.classList.contains('product-reviews__sub')) {
        setTimeout(() => {
          content.style.maxHeight = 'initial';
        }, 300);
      }
    }
    parent.classList.toggle('active');
    let event = new CustomEvent('accordion:toggle');
    document.dispatchEvent(event);
  });
});

document.querySelectorAll('.spotlight-wrapper').forEach((element) => {
  const illustrations = element.querySelectorAll('img, video');
  illustrations.forEach((i) => {
    i.addEventListener('click', (e) => {
      const images = [];
      let spotlightIndex = -1;
      illustrations.forEach((img) => {
        if (img.parentElement.tagName === 'VIDEO' || img.closest('.product-gallery__video')) {
          return;
        }
        if (img === e.currentTarget) {
          spotlightIndex = images.length;
        }
        images.push({
          src: img.dataset.fullSize || img.src,
        });
      });
      if (e.currentTarget.tagName === 'VIDEO') {
        let video = e.currentTarget;
        if (video.paused) {
          video.parentElement.classList.remove('paused');
          video.play();
        } else {
          video.parentElement.classList.add('paused');
          video.pause();
        }
        return;
      }
      if (spotlightIndex === -1) {
        return;
      }
      showSpotlight(images, spotlightIndex)
    });
  })
});

function showSpotlight(images, index, options = {}) {
  Spotlight.show(images, {
    index: index + 1,
    autohide: false,
    control: 'close,next,prev,zoom',
    animation: isMobile ? 'slide' : 'slide,zoom',
    ...options,
  });
  if (isMobile && !window.disableMobileAutoZoom) {
    Spotlight.zoom(1.51);
  }
}

function isBelowViewport(el) {
  const rect = el.getBoundingClientRect();
  return rect.top + el.offsetHeight > window.innerHeight;
}

function initVideoPreviews(root = document) {
  root.querySelectorAll('.video-product video[data-preview-mobile]').forEach((video) => {
    if (video.hasAttribute('src')) return;
    video.src = window.matchMedia('(max-width: 992px)').matches
      ? video.dataset.previewMobile
      : video.dataset.previewDesktop || video.dataset.previewMobile;
  });
}

initVideoPreviews();
document.addEventListener('shopify:section:load', (event) => initVideoPreviews(event.target));

document.querySelectorAll('.video-product__unmute').forEach((videoButton) => {
  videoButton.addEventListener('click', (e) => {
    e.preventDefault();
    const video = videoButton.parentElement.querySelector('video');
    let btn = e.currentTarget;
    if (btn.dataset.fullVideo && btn.dataset.mobVideo) {
      let currentTime = video.currentTime;
      if (window.matchMedia('(max-width: 992px)').matches) {
        video.src = btn.dataset.mobVideo;
      } else {
        video.src = btn.dataset.fullVideo;
      }
      video.load();
      video.currentTime = currentTime;
      video.muted = false;
      video.loop = false;
    } else {
      video.muted = false;
    }
    e.currentTarget.style.display = 'none';
    video.setAttribute('controls', true);
    videoButton.parentElement.classList.add('playing')
  });
});


document.querySelectorAll('.video-product__play').forEach((videoButton) => {
  videoButton.addEventListener('click', (e) => {
    e.preventDefault();
    const video = videoButton.parentElement.querySelector('video');
    let btn = e.currentTarget;
    if (btn.dataset.fullVideo && btn.dataset.mobVideo) {
      video.style.width = '100%';
      video.style.height = 'auto';

      let currentTime = video.currentTime;
      if (window.matchMedia('(max-width: 992px)').matches) {
        video.src = btn.dataset.mobVideo;
      } else {
        video.src = btn.dataset.fullVideo;
      }
      video.load();
      video.currentTime = currentTime;
      video.muted = false;
      video.loop = false;
    }
    if (!video.paused && !video.ended && video.readyState > 2) {
      video.pause();
      videoButton.parentElement.classList.remove('playing');
      video.removeAttribute('controls', null);
    } else {
      video.play();
      videoButton.parentElement.classList.add('playing');
      video.setAttribute('controls', true);
    }
  });
});

document.querySelectorAll('.illustration__title, .product .title').forEach((title) => {
  let text = title.textContent.toLowerCase();
  let letters = ['y', 'n', 't', 'p', 'r', 'd', 'b', 'h', 'u', 'j'];
  letters.forEach((letter) => {
    if (text.trim().indexOf(letter) === 0) {
      title.classList.remove('illustration__title--nomargin');
      title.classList.add('margin--letter-' + letter);
    }
  });
});

document.querySelectorAll('.js-input').forEach((input) => {
  input.addEventListener('change', (e) => {
    const input = e.target;
    if (!input.parentElement.querySelector('.form__label')) {
      return;
    }
    if (input.value) {
      input.parentElement.querySelector('.form__label').classList.add('form__label--active');
    } else {
      input.parentElement.querySelector('.form__label').classList.remove('form__label--active');
    }
  });
});

function formatMoney(amount, e) {
  if ("string" == typeof amount) {
    amount = amount.replace('.', '');
  }
  let i = '';
  const n = /\{\{\s*(\w+)\s*\}\}/,
    s = e || "${{amount}}";
  function o(t, e=2, i=",", n=".") {
      if (isNaN(t) || null == t)
          return 0;
      const s = (t = (t / 100).toFixed(e)).split(".");
      return s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${i}`) + (s[1] ? n + s[1] : "")
  }
  switch (s.match(n)[1]) {
    case "amount":
      i = o(amount, 2);
      break;
    case "amount_no_decimals":
      i = o(amount, 0);
      break;
    case "amount_with_comma_separator":
      i = o(amount, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      i = o(amount, 0, ".", ",")
  }
  return s.replace(n, i)
}

let dropdowns = document.querySelectorAll('.switch');
document.querySelectorAll('.switch').forEach((element) => {
  element.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    dropdowns.forEach(el => {
      if (el !== element) {
        el.classList.remove('active')
      };
    });
    element.classList.toggle('active');
    if (element.classList.contains('active')) {
      document.body.classList.add('switch-open');
      setTimeout(() => {
        let active = element.querySelector('.active');
        let dropdown = element.querySelector('.modal-choose__list');
        let wrapper = element.querySelector('.modal-choose');
        wrapper.innerHeight = dropdown.scrollHeight;
        if (!active) {
          return;
        }
        dropdown.scrollTo({
          top: active.offsetTop - dropdown.clientHeight / 2 - active.clientHeight / 2,
        });
      }, 10);
    } else {
      document.body.classList.remove('switch-open');
    }
  });

  const chooseSearchInput = element.querySelector('.modal-choose .form__input');
  if (!chooseSearchInput || element.dataset.dropdownType) {
    return;
  }
  chooseSearchInput.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  });
  chooseSearchInput.addEventListener('keyup', (e) => {
    let elements = window[element.dataset.variable];
    if (!Array.isArray(elements)) {
      return;
    }
    if (e.currentTarget.value) {
      let val = e.currentTarget.value.toLowerCase();
      elements = elements.filter((el) => {
        return el.name.toLowerCase().indexOf(val) !== -1;
      });
    }
    let html = '';
    elements.forEach((el) => {
      html += `<div class="modal-choose__item" data-code="${el.code}"><span class="modal-choose__item-text">${el.name}${el.currency ? (' - ' + el.currency) : ''}</span></div>`;
    });
    element.querySelector('.modal-choose__list').innerHTML = html;
    initDropdowns();
  });
});

document.querySelectorAll('.modal-choose').forEach((element) => {
  element.addEventListener('click', (e) => {
    e.stopPropagation();
  });
});

document.querySelectorAll('body, .menu').forEach((element) => {
  element.addEventListener('click', (e) => {
    dropdowns.forEach((el) => {
      if (el.classList.contains('active')) {
        document.body.classList.remove('switch-open');
        el.classList.remove('active');
        e.preventDefault();
      }
    });
  });
});

function initDropdowns() {
  document.querySelectorAll('.modal-choose__item').forEach((element) => {
    let switchElement = element.closest('.switch');
    if (!switchElement || switchElement.dataset.dropdownType) {
      return;
    }
    if (element.dataset.dropdownInitialized === 'true') {
      return;
    }
    element.dataset.dropdownInitialized = 'true';
    element.addEventListener('click', (e) => {
      e.stopPropagation();
      let code = element.dataset.code;
      let form = switchElement.querySelector('form');
      if (!form) {
        return;
      }
      let input = form.querySelector('[data-input]');
      if (!input) {
        return;
      }
      input.value = code;
      form.submit();
    });
  });
}
initDropdowns();



document.querySelectorAll('.product-info__lang-item:not(.product-info__lang-item--amount):not(.product-info__lang-item--date):not(.product-info__lang-item--option)').forEach((element) => {
  element.addEventListener('click', (e) => {
    e.currentTarget.classList.add('is-loading');
  });
});

document.querySelectorAll('.product-info__lang-item--option').forEach((element) => {
  element.addEventListener('click', (e) => {
    let el = e.currentTarget;
    el.parentElement.querySelectorAll('.product-info__lang-item--option').forEach((i) => {
      i.classList.remove('active');
    });
    el.classList.add('active');
    let form = el.closest('form');
    let variantId = el.querySelector('input').dataset.variantId;
    form.querySelector('[name=id]').value = variantId;
    const url = new URL(window.location);
    url.searchParams.set('variant', variantId);

    history.replaceState(null, "", url);
  });
});

let isCartCurrencyUpdated = false;

try {
  isCartCurrencyUpdated = window.localStorage.getItem('cart-currency') === '1';
} catch {}

if (!isCartCurrencyUpdated) {
  setTimeout(async function () {
    try {
      await fetch('/services/currency/update?currency=' + Shopify.currency.active + '&country=' + Shopify.country);

      try {
        window.localStorage.setItem('cart-currency', '1');
      } catch {}
    } catch {}
  }, 5000);
}

document.querySelectorAll('.product-gallery__slider-bot').forEach((element) => {
  element.addEventListener('click', (e) => {
    document.querySelector('.product-gallery__slider .swiper-slide-active img').click();
  });
});

document.querySelectorAll('.product-info .product__stars').forEach((star) => {
  star.addEventListener('click', (e) => {
    const reviews = document.querySelector('.product-reviews__title');
    if (!reviews) {
      return;
    }
    smoothScroll(reviews, 1000);
  });
});

document.querySelectorAll('.js-scrollto').forEach((el) => {
  el.addEventListener('click', (e) => {
    e.preventDefault();
    const target = document.querySelector(el.dataset.target);
    if (!target) {
      return;
    }
    let offset = el.dataset.offset || 100;
    smoothScroll(target, el.dataset.speed || 1000, offset);
  });
});

function smoothScroll(target, duration, offset) {
  offset = offset || 100;
  const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;
  const startPosition = window.pageYOffset;
  const distance = targetPosition - startPosition;
  let startTime = null;

  function animation(currentTime) {
    if (startTime === null) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const run = ease(timeElapsed, startPosition, distance, duration);
    window.scrollTo(0, run);
    if (timeElapsed < duration) requestAnimationFrame(animation);
  }

  function ease(t, b, c, d) {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t + b;
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
  }

  requestAnimationFrame(animation);
}

document.querySelectorAll('[data-modal]').forEach((element) => {
  element.addEventListener('click', (e) => {
    e.preventDefault();
    showModal(element.dataset.modal);
  });
});

document.querySelectorAll('.product-info__lang-item--table').forEach((element) => {
  element.addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelectorAll('table[data-table]').forEach((t) => {
      t.style.display = 'none';
    });
    document.querySelector(element.dataset.table).style.display = 'table';
  });
});


function showModal(query) {
  let modal = document.querySelector(query);
  if (!modal) {
    return;
  }
  modal.classList.add('active');
  document.body.classList.add('modal-open');
  const event = new CustomEvent('modal:opened', {
    bubbles: true,
    detail: {
      modal,
    },
  });
  modal.dispatchEvent(event);
}

function openModalFromLocation() {
  let modalId = null;

  if (window.location.hash) {
    modalId = window.location.hash.slice(1);
  }

  if (!modalId) {
    return;
  }

  modalId = modalId.replace(/^#/, '');

  let modal = document.getElementById(modalId);

  if (!modal || !modal.classList.contains('modal')) {
    return;
  }

  showModal(`#${modal.id}`);
}

openModalFromLocation();

function closeModal(targetModal) {
  document.body.classList.remove('modal-open');
  let modal = targetModal || document.querySelector('.modal.active');
  if (modal) {
    modal.classList.remove('active');
    const event = new CustomEvent('modal:closed', {
      bubbles: true,
      detail: {
        modal,
      },
    });
    modal.dispatchEvent(event);
  }
}

document.querySelectorAll('.modal-block__close, .js-close-modal').forEach((element) => {
  element.addEventListener('click', (e) => {
    closeModal();
  });
});

document.querySelectorAll('.modal:not(.modal--strict)').forEach((element) => {
  element.addEventListener('click', (e) => {
    closeModal();
  });
});

document.querySelectorAll('.modal-block').forEach((element) => {
  element.addEventListener('click', (e) => {
    e.stopPropagation();
  });
});

document.addEventListener('keyup', (e) => {
  if (e.key === 'Escape') {
    const activeModal = document.querySelector('.modal.active');
    if (!activeModal || !activeModal.classList.contains('modal--strict')) {
      closeModal(activeModal);
    }
  }
});

async function submitFormData(form) {
  const endpoint = form.getAttribute('action');
  if (!endpoint) {
    throw new Error('Form action is missing.');
  }

  const response = await fetch(endpoint, {
    method: form.getAttribute('method') || 'POST',
    body: new FormData(form),
    headers: {
      Accept: 'application/json',
    },
  });
  let payload = null;

  try {
    payload = await response.json();
  } catch {}

  return {
    response,
    payload,
    isSuccess: response.ok && (!payload || payload.success !== false),
  };
}

function initBackInstock() {
  let form = document.querySelector('.form--notify');
  if (!form) {
    return;
  }
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const modal = form.closest('.modal--notify');
    const errorBlock = modal ? modal.querySelector('[data-notify-error]') : form.querySelector('[data-notify-error]');
    const successBlock = modal ? modal.querySelector('[data-notify-success]') : form.querySelector('[data-notify-success]');
    if (errorBlock) errorBlock.style.display = 'none';
    if (successBlock) successBlock.style.display = 'none';

    const endpoint = form.getAttribute('action');
    if (!endpoint) {
      if (errorBlock) {
        errorBlock.style.display = 'block';
      };
      return;
    }

    const button = form.querySelector('button[type="submit"]');
    if (button) {
      button.disabled = true;
      button.classList.add('is-loading');
    }
    try {
      const { isSuccess } = await submitFormData(form);

      if (isSuccess) {
        form.reset();
        if (successBlock) {
          successBlock.style.display = 'block';
          modal.querySelectorAll('.modal-block__text').forEach((group) => {
            group.style.display = 'none';
          });
        }
        form.style.display = 'none';
      } else if (errorBlock) {
        errorBlock.style.display = 'block';
      }
    } catch {
      if (errorBlock) {
        errorBlock.style.display = 'block'
      };
    } finally {
      if (button) {
        button.disabled = false;
        button.classList.remove('is-loading');
      }
    }
  });
}

if (document.querySelector('.form--notify')) {
  initBackInstock();
}

let turnstileLoadPromise = null;

function loadTurnstile() {
  if (window.turnstile) {
    return Promise.resolve(window.turnstile);
  }

  if (turnstileLoadPromise) {
    return turnstileLoadPromise;
  }

  turnstileLoadPromise = new Promise((resolve, reject) => {
    const existingScript = document.querySelector('[data-turnstile-script]');
    if (existingScript) {
      existingScript.addEventListener('load', () => resolve(window.turnstile));
      existingScript.addEventListener('error', reject);
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    script.async = true;
    script.defer = true;
    script.dataset.turnstileScript = 'true';
    script.addEventListener('load', () => resolve(window.turnstile));
    script.addEventListener('error', reject);
    document.head.appendChild(script);
  });

  return turnstileLoadPromise;
}

function createTurnstileController({ container, responseInput, action, appearance, onVerified, onError, onLoadError }) {
  let widgetId = null;

  const clearResponse = () => {
    if (responseInput) {
      responseInput.value = '';
    }
  };

  const reset = () => {
    clearResponse();

    if (widgetId !== null && window.turnstile) {
      window.turnstile.reset(widgetId);
    }
  };

  const render = () => {
    if (!container || widgetId !== null || container.dataset.rendering === 'true') {
      return;
    }

    const sitekey = container.dataset.sitekey;
    if (!sitekey) {
      return;
    }

    container.dataset.rendering = 'true';

    loadTurnstile()
      .then((turnstile) => {
        widgetId = turnstile.render(container, {
          sitekey,
          ...(action ? { action } : {}),
          ...(appearance ? { appearance } : {}),
          callback: (token) => {
            if (responseInput) {
              responseInput.value = token;
            }
            if (onVerified) onVerified(token);
          },
          'expired-callback': clearResponse,
          'error-callback': () => {
            clearResponse();
            if (onError) onError();
          },
        });
      })
      .catch(() => {
        if (onLoadError) onLoadError();
      })
      .finally(() => {
        delete container.dataset.rendering;
      });
  };

  return { render, reset };
}

function initEmailSubscriptionForms() {
  document.querySelectorAll('[data-email-subscription-form]').forEach((form) => {
    if (form.dataset.emailSubscriptionInit === 'true') {
      return;
    }

    form.dataset.emailSubscriptionInit = 'true';

    const modal = form.closest('.modal');
    const errorBlock = modal ? modal.querySelector('[data-email-subscription-error]') : form.querySelector('[data-email-subscription-error]');
    const successBlock = modal ? modal.querySelector('[data-email-subscription-success]') : form.querySelector('[data-email-subscription-success]');
    const introBlocks = modal ? modal.querySelectorAll('[data-email-subscription-intro]') : [];
    const submitButton = form.querySelector('button[type="submit"]');
    const emailInput = form.querySelector('input[name="email"]');
    const emailError = form.querySelector('[data-email-subscription-email-error]');
    const emailGroup = emailInput ? emailInput.closest('.form__group') : null;
    const turnstileContainer = form.querySelector('[data-turnstile-container]');
    const turnstileResponse = form.querySelector('[data-turnstile-response]');

    const setMessage = (element, visible) => {
      if (!element) {
        return;
      }

      element.style.display = visible ? 'block' : 'none';
    };

    const clearEmailError = () => {
      if (emailError) {
        emailError.textContent = '';
        emailError.hidden = true;
      }

      if (emailInput) {
        emailInput.removeAttribute('aria-invalid');
      }

      if (emailGroup) {
        emailGroup.classList.remove('form__group--error');
      }
    };

    const showEmailError = (message) => {
      if (!emailError || !message) {
        return;
      }

      emailError.textContent = message;
      emailError.hidden = false;

      if (emailInput) {
        emailInput.setAttribute('aria-invalid', 'true');
      }

      if (emailGroup) {
        emailGroup.classList.add('form__group--error');
      }
    };

    const resetFormState = () => {
      form.reset();
      form.style.display = '';
      delete form.dataset.loading;
      clearEmailError();

      if (submitButton) {
        submitButton.disabled = false;
        submitButton.classList.remove('is-loading');
      }

      introBlocks.forEach((block) => {
        block.style.display = '';
      });

      setMessage(errorBlock, false);
      setMessage(successBlock, false);
    };

    const {
      render: renderTurnstile,
      reset: resetTurnstile,
    } = createTurnstileController({
      container: turnstileContainer,
      responseInput: turnstileResponse,
      onVerified: () => setMessage(errorBlock, false),
      onLoadError: () => setMessage(errorBlock, true),
    });

    if (modal) {
      modal.addEventListener('modal:opened', () => {
        renderTurnstile();
      });
      modal.addEventListener('modal:closed', () => {
        resetFormState();
        resetTurnstile();
      });

      if (modal.classList.contains('active')) {
        document.body.classList.add('modal-open');
        renderTurnstile();
      }
    } else {
      renderTurnstile();
    }

    if (emailInput) {
      emailInput.addEventListener('input', clearEmailError);
    }

    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      if (form.dataset.loading === 'true') {
        return;
      }

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      if (turnstileContainer) {
        renderTurnstile();

        if (!turnstileResponse || !turnstileResponse.value) {
          setMessage(errorBlock, true);
          return;
        }
      }

      const endpoint = form.getAttribute('action');
      if (!endpoint) {
        setMessage(errorBlock, true);
        return;
      }

      form.dataset.loading = 'true';
      clearEmailError();
      setMessage(errorBlock, false);
      setMessage(successBlock, false);

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.classList.add('is-loading');
      }

      try {
        const { response, payload, isSuccess } = await submitFormData(form);
        const isValidationError = response.status === 422 || (payload && payload.code === 422);
        const emailErrors = payload && payload.errors && payload.errors.email;
        const emailErrorMessage = Array.isArray(emailErrors) ? emailErrors[0] : null;

        if (isSuccess) {
          form.reset();
          form.style.display = 'none';
          introBlocks.forEach((block) => {
            block.style.display = 'none';
          });
          setMessage(successBlock, true);

          if (form.dataset.closeOnSuccess === 'true' && modal) {
            closeModal(modal);
          }
        } else if (isValidationError && emailErrorMessage) {
          showEmailError(emailErrorMessage);
          resetTurnstile();
        } else {
          setMessage(errorBlock, true);
          resetTurnstile();
        }
      } catch {
        setMessage(errorBlock, true);
        resetTurnstile();
      } finally {
        delete form.dataset.loading;

        if (submitButton) {
          submitButton.disabled = false;
          submitButton.classList.remove('is-loading');
        }
      }
    });
  });
}

initEmailSubscriptionForms();

function initFeedbackForms() {
  document.querySelectorAll('[data-feedback-form]').forEach((form) => {
    if (form.dataset.feedbackFormInit === 'true') {
      return;
    }

    form.dataset.feedbackFormInit = 'true';

    const section = form.closest('[data-feedback-form-container]');
    const errorBlock = section ? section.querySelector('[data-feedback-error]') : null;
    const successBlock = section ? section.querySelector('[data-feedback-success]') : null;
    const submitButton = form.querySelector('button[type="submit"]');
    const turnstileContainer = form.querySelector('[data-turnstile-container]');
    const turnstileResponse = form.querySelector('[data-turnstile-response]');

    const setMessage = (element, visible) => {
      if (element) {
        element.hidden = !visible;
      }
    };
    let hasErrorResponse = false;
    const {
      render: renderTurnstile,
      reset: resetTurnstile,
    } = createTurnstileController({
      container: turnstileContainer,
      responseInput: turnstileResponse,
      action: form.dataset.turnstileAction,
      onVerified: function () {
        setMessage(errorBlock, hasErrorResponse)
      },
      onError: () => setMessage(errorBlock, true),
      onLoadError: () => setMessage(errorBlock, true),
    });

    if (turnstileContainer && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          renderTurnstile();
          observer.disconnect();
        }
      });
      observer.observe(form);
    } else {
      form.addEventListener('focusin', renderTurnstile, { once: true });
    }

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      if (form.dataset.loading === 'true') {
        return;
      }

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      if (!turnstileContainer || !turnstileResponse || !turnstileResponse.value) {
        renderTurnstile();
        setMessage(errorBlock, true);
        return;
      }

      form.dataset.loading = 'true';
      setMessage(errorBlock, false);

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.classList.add('is-loading');
      }
      
      try {
        hasErrorResponse = false;
        const { isSuccess } = await submitFormData(form);

        if (!isSuccess) {
          setMessage(errorBlock, true);
          resetTurnstile();
          hasErrorResponse = true;
          return;
        }

        form.reset();
        form.hidden = true;
        setMessage(successBlock, true);
        smoothScroll(document.querySelector('header'), 1000);
      } catch {
        setMessage(errorBlock, true);
        resetTurnstile();
        hasErrorResponse = true;
      } finally {
        delete form.dataset.loading;

        if (submitButton) {
          submitButton.disabled = false;
          submitButton.classList.remove('is-loading');
        }
      }
    });
  });
}

initFeedbackForms();

document.querySelectorAll('.js-contact-form').forEach((form) => {
  const modal = form.closest('.modal');
  const errorBlock = form.querySelector('.error');
  const successBlock = modal ? modal.querySelector('.success') : form.parentElement.querySelector('.success');

  const resetModalState = () => {
    form.reset();
    form.style.display = '';
    if (errorBlock) {
      errorBlock.style.display = 'none';
    }
    if (successBlock) {
      successBlock.style.display = 'none';
    }
  };

  if (modal) {
    modal.addEventListener('modal:closed', () => {
      resetModalState();
    });
  }

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const button = form.querySelector('button[type="submit"]') || form.querySelector('button');
    if (errorBlock) {
      errorBlock.style.display = 'none';
    }
    if (button) {
      button.disabled = true;
      button.classList.add('is-loading');
    }
    try {
      const { payload } = await submitFormData(form);
      if (payload && payload.success) {
        form.reset();
        if (successBlock) {
          successBlock.style.display = 'block';
        }
        form.style.display = 'none';
      } else if (errorBlock) {
        errorBlock.style.display = 'block';
      }
    } catch {
      if (errorBlock) {
        errorBlock.style.display = 'block';
      }
    } finally {
      if (button) {
        button.disabled = false;
        button.classList.remove('is-loading');
      }
    }
  });
});

document.querySelectorAll('.js-footer-form').forEach((form) => {
  const button = form.querySelector('button[type="submit"]');
  const errorBlock = form.querySelector('[data-footer-form-error]');
  const formContainer = form.closest('.footer-block__subscribe') || form.parentElement;
  const successBlock = formContainer ? formContainer.querySelector('[data-footer-form-success]') : null;
  const defaultErrorHTML = errorBlock ? errorBlock.innerHTML : '';
  const turnstileContainer = form.querySelector('[data-turnstile-container]');
  const turnstileResponse = form.querySelector('[data-turnstile-response]');

  const toggleMessage = (element, show) => {
    if (!element) {
      return;
    }
    element.hidden = !show;
  };

  const showError = (message) => {
    if (!errorBlock) {
      return;
    }
    errorBlock.innerHTML = defaultErrorHTML;
    if (message) {
      errorBlock.textContent = message;
    }
    toggleMessage(errorBlock, true);
  };

  const getErrorMessage = () => {
    return '';
  };

  const {
    render: renderTurnstile,
    reset: resetTurnstile,
  } = createTurnstileController({
    container: turnstileContainer,
    responseInput: turnstileResponse,
    action: turnstileContainer ? turnstileContainer.dataset.action : '',
    appearance: turnstileContainer ? turnstileContainer.dataset.appearance : '',
    onVerified: () => toggleMessage(errorBlock, false),
    onError: () => showError(),
    onLoadError: () => showError(),
  });

  if (turnstileContainer) {
    form.addEventListener('focusin', renderTurnstile, { once: true });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          renderTurnstile();
          observer.disconnect();
        }
      });

      observer.observe(form);
    }
  }

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    if (form.dataset.loading === 'true') {
      return;
    }

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    if (turnstileContainer) {
      renderTurnstile();

      if (!turnstileResponse || !turnstileResponse.value) {
        showError();
        return;
      }
    }

    const endpoint = form.getAttribute('action');
    if (!endpoint) {
      showError();
      return;
    }

    form.dataset.loading = 'true';
    toggleMessage(errorBlock, false);
    toggleMessage(successBlock, false);

    if (errorBlock) {
      errorBlock.innerHTML = defaultErrorHTML;
    }
    if (button) {
      button.disabled = true;
      button.classList.add('is-loading');
    }

    try {
      const { payload, isSuccess } = await submitFormData(form);

      if (isSuccess) {
        form.reset();
        form.hidden = true;
        toggleMessage(successBlock, true);
      } else {
        showError(getErrorMessage(payload));
        resetTurnstile();
      }
    } catch {
      showError();
      resetTurnstile();
    } finally {
      delete form.dataset.loading;
      if (button) {
        button.disabled = false;
        button.classList.remove('is-loading');
      }
    }
  });
});

let klaviyoFormsEvents = {};
window.addEventListener('klaviyoForms', function (e) {
  const detail = e.detail || {};
  let type = detail.type;
  let formId = detail.formId;
  let allowedFormIds = ['Y5p4Ux', 'SEER5k', 'UGgrRP', 'YgTaTN'];
  if (allowedFormIds.indexOf(formId) === -1) {
    return;
  }
  if (klaviyoFormsEvents[type]) {
    return;
  }
  klaviyoFormsEvents[type] = true;
  window.igEvents = window.igEvents || [];
  if (type === 'open') {
    window.igEvents.push({'event': '5forfree-popped'});
  } else  if (type === 'submit') {
    window.igEvents.push({'event': '5forfree-submitted'});
  }
});

document.querySelectorAll('.blog-list__tabs a').forEach((link) => {
  link.addEventListener('click', (e) => {
    let blogItems = document.querySelector('.blog-list__items');
    e.preventDefault();
    document.querySelectorAll('.blog-list__tab--active').forEach((link) => {
      link.classList.remove('blog-list__tab--active');
    });
    e.target.classList.add('blog-list__tab--active');
    blogItems.classList.add('loading');

    if (document.querySelector('.blog-list__tabs-list')) {
      document.querySelector('.blog-list__tabs-list').classList.remove('blog-list__tabs-list--active');
      document.querySelector('.blog-list__tabs-current span').textContent = e.target.textContent;
    }
    const sectionId = blogItems.closest('.shopify-section').id.replace('shopify-section-', '');
    fetch(`${link.href}?section_id=${sectionId}`)
      .then((response) => response.text())
      .then((html) => {
        let div = document.createElement('div');
        div.innerHTML = html;
        blogItems.innerHTML = div.querySelector('.blog-list__items').innerHTML;
        history.replaceState({}, '', link.href);
      }).finally((error) => {
        blogItems.classList.remove('loading');
      });
  });
});

if (document.querySelector('.blog-list__tabs-current')) {
  document.querySelector('.blog-list__tabs-current').addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelector('.blog-list__tabs-list').classList.toggle('blog-list__tabs-list--active');
    document.querySelector('.blog-list__tabs-current').classList.toggle('blog-list__tabs-current--active');
  });
}


document.querySelectorAll('.video-product__video--hide').forEach((video) => {
  video.addEventListener('click', (e) => {
    if (e.currentTarget.parentElement.classList.contains('playing')) {
      e.preventDefault();
      video.removeAttribute('autoplay', null);
      video.pause();
      video.currentTime = video.currentTime;

      video.parentElement.classList.remove('playing');
      video.removeAttribute('controls', null);
    }
  });
});
